var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HbUnitIcon',{staticClass:"pr-1",attrs:{"small":"","color":"#101318","type":_vm.getUnitTypeLabel(_vm.params.data)}}),_c('span',[_vm._v(_vm._s(_vm.unitNumber))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }